import styled from "styled-components";

import { ExpressionEditorValueFirst } from "../ExpressionEditorValueFirst";
import { ExpressionConfiguration } from "../../../rule-engine-core/Expressions/ExpressionConfiguration";
import { BooleanDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { DateDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/DateDataDefinition";
import { NumberDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { ExpressionValueType } from "../../../rule-engine-core/Expressions/ExpressionValueType";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { StoryNode } from "../../StoryBook/StoryData";
import type { AppGlueAny } from "../../../rule-engine-core/Common/AppGlueAny";

const Cell = styled.div`
    min-width: 120px;
    border: solid 1px lightblue;
    display: inline-block;
    align-items: center;
`;

const factory = (type: IDataDefinition): ExpressionConfiguration => {
    let expression = new ExpressionConfiguration();
    let expectedType = type;
    expression.expressionRoot.expectedType = expectedType;

    expression.executionResult = () => {
        return expectedType;
    };

    return expression;
};

export const ValueOrExpressionStories = [
    new StoryNode(
        () => {
            let booleanExpression = factory(new BooleanDataDefinition("boolean"));

            return (
                <Cell>
                    <ExpressionEditorValueFirst
                        expression={booleanExpression}
                        onUpdate={(newValue: ExpressionConfiguration | AppGlueAny) => {
                            if (newValue instanceof ExpressionConfiguration) {
                            } else {
                                booleanExpression.value = newValue;
                                booleanExpression.valueType = ExpressionValueType.VALUE;
                            }
                        }}
                    />
                </Cell>
            );
        },

        "Shared",
        "Data Designer",
        "Value or Expression",
        "Boolean",
    ),
    new StoryNode(
        () => {
            let stringExpression = factory(new StringDataDefinition("string"));

            return (
                <Cell>
                    <ExpressionEditorValueFirst
                        expression={stringExpression}
                        onUpdate={(newValue: ExpressionConfiguration | AppGlueAny) => {
                            if (newValue instanceof ExpressionConfiguration) {
                            } else {
                                stringExpression.value = newValue;
                                stringExpression.valueType = ExpressionValueType.VALUE;
                            }
                        }}
                    />
                </Cell>
            );
        },

        "Shared",
        "Data Designer",
        "Value or Expression",
        "String",
    ),
    new StoryNode(
        () => {
            let dateExpression = factory(new DateDataDefinition("date"));
            return (
                <Cell>
                    <ExpressionEditorValueFirst
                        expression={dateExpression}
                        onUpdate={(newValue: ExpressionConfiguration | AppGlueAny) => {
                            if (newValue instanceof ExpressionConfiguration) {
                            } else {
                                dateExpression.value = newValue;
                                dateExpression.valueType = ExpressionValueType.VALUE;
                            }
                        }}
                    />
                </Cell>
            );
        },

        "Shared",
        "Data Designer",
        "Value or Expression",
        "Date",
    ),
    new StoryNode(
        () => {
            let numberExpression = factory(new NumberDataDefinition("number"));
            return (
                <Cell>
                    <ExpressionEditorValueFirst
                        expression={numberExpression}
                        onUpdate={(newValue: ExpressionConfiguration | AppGlueAny) => {
                            if (newValue instanceof ExpressionConfiguration) {
                            } else {
                                numberExpression.value = newValue;
                                numberExpression.valueType = ExpressionValueType.VALUE;
                            }
                        }}
                    />
                </Cell>
            );
        },

        "Shared",
        "Data Designer",
        "Value or Expression",
        "Number",
    ),
];
